import styled from 'styled-components'
import { device } from '../../../styles/GlobalVariables'

export const ProgramSeriesWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  margin-top: 15px;
  z-index: 1;

  div[class*='OttTaboolastyle__OttTaboolaWrap'] {
    padding: 0;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 26px;
    gap: 4vw;
    padding: 0 25px;
  }

  a {
    text-decoration: none;
  }
`

export const TaboolaWidgetWrapper = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  position: relative;
  top: 40px;
  margin: 30px auto;

  .trc_elastic .trc_rbox {
    width: 1680px;
  }
`

export const ProgramSeriesWrapClip = styled.div`
  margin: 26px auto auto;
  gap: 20px;
  display: flex;
  flex-direction: column;

  ${device.medium} {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 22px;
    width: 88vw;
    margin-bottom: 30px;
    margin-top: 30px;
  }

  @media only screen and (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr;
    padding: 0 6vw;
  }

  div[class*='OttTaboolaWrap'] {
    padding: 0;
  }
`
export const HiddenItem = styled.div`
  display: none;
`
